import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=f7fc54e2&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/Dashboard/DashboardStyle.css?vue&type=style&index=0&id=f7fc54e2&prod&scoped=true&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=f7fc54e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fc54e2",
  null
  
)

export default component.exports